import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, currencyNote, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="inversion" className="w-full bg-white py-16 md:py-24" data-id="element-101" data-mp="2jkxh3bab1yxi">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-102" data-mp="1vt9ydgn75u6b">
        {showUrgency && <CountdownPanel headline="Attenzione: questa offerta di lancio scade tra 48 ore" subtext="Dopo, il prezzo aumenta a 47,00 €. Domani è tardi." data-id="element-103" data-mp="1rsydc2qx9rub" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-night md:text-5xl" data-id="element-104" data-mp="20slhgwb1dbr2">
          Il tuo investimento oggi
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-3xl bg-canvas p-7 text-center shadow-lift ring-1 ring-gray-200 md:p-12" data-id="element-105" data-mp="3c8jwrhwt4u0q">
          <p className="text-lg text-gray-500" data-id="element-106" data-mp="3vyf6oqmway1b">
            Valore senza sconto: <span className="line-through" data-id="element-107" data-mp="4svvdoosx0sc">{offer.listPrice}</span>
          </p>

          <p className="mt-4 font-display text-6xl font-extrabold leading-none tracking-tight text-night md:text-7xl" data-id="element-108" data-mp="4uyrmqgjrq5i">
            {offer.price}
            <span className="ml-2 align-middle text-xl font-semibold text-gray-500" data-id="element-109" data-mp="eqac7pemzrl6">
              {offer.currency}
            </span>
          </p>

          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-gray-500" data-id="element-110" data-mp="3d74hqf0qcvc2">
            {currencyNote}
          </p>

          <p className="mt-5 inline-block rounded-lg bg-amber-400 px-4 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-night" data-id="element-111" data-mp="3n6lj4k8y8n28">
            {offer.subtitle}
          </p>

          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-gray-600" data-id="element-112" data-mp="2uizi9jr3vwj2">
            {offer.detail}
          </p>

          <div className="mt-9" data-id="element-113" data-mp="2zgiy2o3gchd4">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-114" data-mp="2zfg427au1ysz">
              {offer.cta}
            </CtaButton>
            <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-gray-500" data-id="element-115" data-mp="2mhru1rdvvm4p">
              {currencyNote}
            </p>
          </div>
        </div>

        <TrustIcons className="mt-10" data-id="element-116" data-mp="315wfh34bmbr6" />
      </div>
    </section>;
}